import { Component, Input, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommonCabService } from '../../services/common-cab.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { ASSETS_PATH_CONST } from '../../../modern-multi-trip-view/constants/image-assets.constants';

@Component({
  selector: 'app-side-view-cab',
  templateUrl: './side-view.component.html',
  styleUrls: ['./side-view.component.scss'],
  animations: [
    trigger('expandedAnimation', [
      state('true', style({ transform: 'rotate(-180deg)', 'transform-origin': '50% 50%' })),
      state('false', style({ transform: 'rotate(0deg)', 'transform-origin': '50% 50%' })),
      transition('false <=> true', animate('0.5s ease-in-out'))
    ]),
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('500ms ease-in-out')
      ])
    ]),
    trigger('rotateArrow', [
      state('collapsed', style({
        transform: 'rotate(0deg)'
      })),
      state('expanded', style({
        transform: 'rotate(180deg)'
      })),
      transition('collapsed => expanded', [
        animate('0.3s')
      ]),
      transition('expanded => collapsed', [
        animate('0.3s')
      ])
    ])
  ]
})
export class SideViewCabComponent implements OnInit {
  @Input() tripReplay:boolean = false;
  @Input() callFromTrip: boolean = true;
  @Input() adhoc_text;
  ASSETS_PATH_CONST = ASSETS_PATH_CONST;
  imgSrc: string;
  constructor(private commonCabService: CommonCabService, private envService: EnvironmentService) { }
  expandedToggler: boolean = true
  employeeStatusCount: any
  response;
  tripDutyToggler: any = 'trip';
  womenTravellingAlone = false;
  nextTripInfo = false;
  oldRoute;
  enableGoToOldRoute=false;
  INFO_ICON;
  adhocTooltipVisible: boolean = true;
  BACK_2_BACK_TRIP_ICON:string = ''
  BACK_2_BACK_VEHICLE_ICON:string = ''
  MARSHALL_ICON:string = ''
  safetyAlert: [];
  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    // this.commonCabService.employeeStatusCount$.subscribe((res)=>
    // {
    //   console.log("employee count ",res.adhocCount);

    //   this.employeeStatusCount=res
    // })

    this.INFO_ICON = `${this.imgSrc}assets/icons/info_icon.svg`;
    this.BACK_2_BACK_TRIP_ICON = `${this.imgSrc}assets/icons/back2back-trip-icon.svg`;
    this.MARSHALL_ICON = `${this.imgSrc}assets/icons/marshal.svg`;
    this.BACK_2_BACK_VEHICLE_ICON = `${this.imgSrc}assets/icons/back2back_trip_icon.svg`
    this.response=this.commonCabService.response;
    this.commonCabService.safetyAlert$.subscribe((res) => {
      this.safetyAlert = res;
    })
    console.log('cabResponse',this.response);
    this.oldRoute=this.commonCabService.createOldRoute();
    this.goToOldEnable();
    
  }

  toolTipClose() {
    this.adhocTooltipVisible = false;
  }

  openModal() {
    // this.testPopup.show(EmployeesDetailsComponent,  { closeOnBackdropClick: true, ...this.initialState });
  }

  expandedToggle() {
    this.expandedToggler = !this.expandedToggler
  }
  tripDutyToggle(value: string) {

    if (value == 'trip') {
      this.tripDutyToggler = 'trip'
    }
    else {
      this.tripDutyToggler = 'duty'
    }

  }
  nextTripPopup() {
    // this.commonCabService.nextTripDetails(this.response['tripDetails']['nextTripGuid']).subscribe((res)=>{
    //   this.nextTripInfo=true;
    //   this.nextTripData=res;

    // })
  }
  gotoTripReplay() {
    this.commonCabService.goToTripReplay();
    this.commonCabService.sendEvent("Trip Replay Opened", "mis_modern_trip_view", "trip_replay", "Yes",this.commonCabService.buid, new Date().toISOString().split('T')[0]);
  }

  gotoOldView() {
    window.parent.location.href = this.oldRoute;
  }
  backToDashboard() {
    this.commonCabService.getEtsUrl().subscribe((url:string)=>{
      let pathname=url+"master.jsp#transport-dashboard"
      window.open(pathname,'_top');
    })

  }


    goToOldEnable(){
     // this.enableGoToOldRoute= this.commonCabService.isDutyIdPresent();
    }

  

}
